<template>
  <Empty v-if="rankings.length === 0" title="분석 결과가 없습니다" description="분석 결과가 없습니다." />
  <div v-else class="org-table-wrapper">
    <div class="table-scroll-container">
      <UiTableDefault>
        <template #colgroup>
          <col width="10%" />
          <col width="20%" />
          <!--          <col width="20%" />-->
          <col width="20%" />
          <col width="20%" />
        </template>
        <template #header>
          <tr>
            <th>순위</th>
            <th>조직명</th>
            <!--            <th>매니저</th>-->
            <th>성과수준</th>
            <th>변화</th>
          </tr>
        </template>
        <template #body>
          <tr v-for="(item, index) in rankings" :key="item.rank">
            <td class="text-center">
              <div class="rank-badge" :class="`rank-${(index % 5) + 1}`">
                {{ item.rank }}
              </div>
            </td>
            <td class="text-center team-name">
              <UiTooltip position="right">
                <template #trigger>
                  {{ item.name }}
                </template>
                <p>매니저 : {{ item.leader }}</p>
              </UiTooltip>
            </td>
            <!--            <td class="text-center">{{ item.leader }}</td>-->
            <td class="text-center score-cell" :class="`score-rank-${(index % 5) + 1}`">
              {{ item.score }}
            </td>
            <td class="text-center">
              <template v-if="item.score == '-'">-</template>
              <div v-else class="change-badge" :class="item.change > 0 ? 'up' : 'down'">
                <img v-if="item.change > 0" src="@/assets/images/icon/icon-up.svg" alt="상승" class="change-icon" />
                <img v-else src="@/assets/images/icon/icon-down.svg" alt="하락" class="change-icon" />
                <span>{{ item.change > 0 ? `+${item.change}` : item.change }}</span>
              </div>
            </td>
          </tr>
        </template>
      </UiTableDefault>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  rankings: Array<{
    rank: number;
    name: string;
    leader: string;
    score: string | number;
    change: number;
  }>;
}>();
</script>

<style scoped lang="scss">
.org-table-wrapper {
  padding: 16px 0;

  .table-scroll-container {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;

    :deep(thead th) {
      position: sticky;
      top: 0;
      background: white;
      z-index: 1;
      box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    }
  }

  .rank-badge {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: #131416;

    &.rank-1 {
      background: #cdd1d5;
    }

    &.rank-2 {
      background: #cdd1d5;
    }

    &.rank-3 {
      background: #cdd1d5;
    }

    &.rank-4 {
      background: #cdd1d5;
    }

    &.rank-5 {
      background: #cdd1d5;
    }
  }

  .team-name {
    font-weight: 700;
    color: #464c53;
    font-size: 14px;
  }

  .score-cell {
    font-weight: 700;
    font-size: 18px;

    &.score-rank-1 {
      color: black;
    }

    &.score-rank-2 {
      color: black;
    }

    &.score-rank-3 {
      color: black;
    }

    &.score-rank-4 {
      color: black;
    }

    &.score-rank-5 {
      color: black;
    }
  }

  .change-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 8px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 700;

    &.up {
      background: #d1f4df;
      color: #00b248;
    }

    &.down {
      background: #ffe2db;
      color: #ff3300;
    }

    .change-icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
